import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type ReStudentSummaryReportingRoute from 'teacher-ui-client/reporting/ui-scope/re/student-summary/route'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type { NormalizedInterval } from 'date-fns'
import type ReStudentSummaryCourseProgressReadingController from 'teacher-ui-client/reporting/ui-scope/re/student-summary/course-progress/reading/controller'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class ReStudentSummaryCourseProgressReadingRoute extends Route {
  @service studentEvents!: StudentEventsService

  queryParams = {
    currentMapNumber: {
      replace: true,
    },
  }

  async model() {
    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const { student } = this.modelFor(
      'reporting.ui-scope.re.student-summary',
    ) as ModelFor<ReStudentSummaryReportingRoute>

    const statsScope: StudentScope = { scope: 'student', ids: [student.id] }

    const product: LegacyProductRe = 're'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      student,
      students: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests(product: LegacyProductRe, scope: StudentScope, period: NormalizedInterval) {
    return RSVP.hash({
      readingMapDetails: this.studentEvents.readingMapDetails(product, scope, period),
    })
  }

  setupController(
    controller: ReStudentSummaryCourseProgressReadingController,
    model: ModelFor<ReStudentSummaryCourseProgressReadingRoute>,
  ) {
    super.setupController(controller, model)
    const mapsData = model.readingMapDetails ?? []
    const mapNumbers = mapsData.map((map) => map.map_number)
    const [firstMapNumber] = mapNumbers
    const { currentMapNumber } = controller
    const currentMapNumberValid = mapNumbers.includes(currentMapNumber)
    if (!currentMapNumberValid) {
      controller.currentMapNumber = firstMapNumber
    }
  }
}
